import React, { Component } from 'react';
import { Card } from 'material-ui/Card';
import Alert from 'react-s-alert';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change, reset } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import { renderAutoCompleteSingleSelect, renderCheckBox, renderDateField, renderTextField } from '../../../../components/reduxFields';
import { getMasterData, deleteUploadedDocument, documentUploadDownload, uploadedDocumentDownload, PreviewDownloadedDocument, BatchInactiveDocuments, BatchActiveDocuments, BatchDeleteDocuments } from '../../../patients/actions/PatientActions';
import UploadDocumentModal from '../../patient_profile_client_modal';
import JPG from '../../../../img/jpg.png';
import DOC from '../../../../img/doc.png';
import EXCEL from '../../../../img/excel.png';
import OTHER from '../../../../img/other.png';
import PDF from '../../../../img/pdf.png';
import PNG from '../../../../img/png.png';
import PPT from '../../../../img/ppt.png';
import TXT from '../../../../img/txt.png';
import moment from 'moment';
import { showWarningMessage, alertConfirmation, showFormatedDate } from '../../../../actions/utilAction';
import RaisedButton from 'material-ui/RaisedButton';
import MoveBatchDocumentsIntoFolderModal from './MoveBatchDocumentsIntoFolderModal';
import folderNames from '../../../../constants/FolderNameConstant';

const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};

class DocumentSubFolderDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,      
      staffId: (props.staffId ? props.staffId : null),
      documentTypes: [],
      patientDocs: [],
      userId: (props.userId ? props.userId : null),      
      ShowOnlyExpiredDocuments: false,
      ShowOnlyInactiveDocuments: false,
      documentTypeId: 0,
      uploadDocumentObj: [], 
      masterFolderId: (props.masterFolderId ? props.masterFolderId : null),
      masterFolderName: (props.masterFolderName ? props.masterFolderName : ''),
      subFolderName: (props.subFolderName ? props.subFolderName : ''),
      subFolderId: (props.subFolderId ? props.subFolderId : null),
      openBatchMoveModal: false,
      selectedDocumentIds: [],      
      userDocumentMasterFolders: [],
      userDocumentSubFolders: [],      
      clientDocs: [],
      FromDate: new Date().setDate(new Date().getDate() - 1825),
      ToDate: new Date(),
    };   
    this.filter = {
      sort_Column: '',
      sort_order: '',     
      searchText: '',
    };
    this.handleCloseHandler = this.handleCloseHandler.bind(this);
    this.uploadDocumenthandler = this.uploadDocumenthandler.bind(this);
    this.handleAlertClick = this.handleAlertClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    //this.handleNewRequest = this.handleNewRequest.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);    
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  loadDataDetails() {    
    let searchObj = {
      userId: this.state.userId,
      fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date(),
      toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
      documentTypeId: this.state.documentTypeId,
      showOnlyExpiredDocuments: this.state.ShowOnlyExpiredDocuments ? true : false,      
      showOnlyInactiveDocuments: this.state.ShowOnlyInactiveDocuments ? true : false,  
      masterFolderId : this.state.masterFolderId,
      subFolderId : this.state.subFolderId,
      searchText: this.filter.searchText || '',  
    };
    this.props.documentUploadDownload(searchObj); // For Listing of uploaded documents
  }



  componentWillMount() {
    this.props.getMasterData('MASTERDOCUMENTTYPES,USERDOCUMENTMASTERFOLDER,USERDOCUMENTSUBFOLDER');
    this.setState({ userId: this.props.userId}, () => {
      if (this.state.userId) {        
        this.loadDataDetails();        
      }       
    });
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.masterData) {
      this.setState({ documentTypes: nextProps.masterData.masterDocumentTypes });
      this.setState({ userDocumentMasterFolders: nextProps.masterData.userDocumentMasterFolder });
      this.setState({ userDocumentSubFolders: nextProps.masterData.userDocumentSubFolder });
    }
    
    if (nextProps.clientDocs && this.props.clientDocs !== nextProps.clientDocs) {
       this.setState({ clientDocs: nextProps.clientDocs });
     }

    
    if (nextProps.saved_MoveBatchDocumentsIntoFolder && nextProps.saved_MoveBatchDocumentsIntoFolder !== this.props.saved_MoveBatchDocumentsIntoFolder) {
      this.ResetAllDocuments();
      this.loadDataDetails();
    }  

    if (nextProps.inactivated_MoveBatchDocuments && nextProps.inactivated_MoveBatchDocuments !== this.props.inactivated_MoveBatchDocuments) {
      this.ResetAllDocuments();
      this.loadDataDetails();
    }  

    if (nextProps.deleted_MoveBatchDocuments && nextProps.deleted_MoveBatchDocuments !== this.props.deleted_MoveBatchDocuments) {
      this.ResetAllDocuments();
      this.loadDataDetails();
    }  
    if (nextProps.delete_Uploaded_Document && nextProps.delete_Uploaded_Document !== this.props.delete_Uploaded_Document) {         
      this.handleReset();      
      this.loadDataDetails();
    } 
  }

  uploadDocumenthandler = () => {
    if (!this.state.userId) {
      showWarningMessage('Please select client to upload document!');
      return false;
    } else {
      this.setState({ open: true, uploadDocumentObj: null });
    }
  }

  handleClose = () => {
    this.setState({
      openBatchMoveModal: false,
      selectedDocumentIds: [],      
    });
    // this.props.loadClaimsData();
    this.props.handleReset();
    this.props.dispatch(reset('DocumentSubFolderDetailsListingForm', 'Chkclaim', null))
  }

  handleCloseHandler = () => {
    this.setState({ open: false });
  };

  handleDownloadClick = (docId, fileName) => {
    this.props.uploadedDocumentDownload(docId, fileName,folderNames.SUB);
  }

  handlePreviewClick = (docId, fileName) => {
    Alert.closeAll();
    this.props.PreviewDownloadedDocument(docId, fileName);
  }

  handleEditClick = (Obj) => {
    // console.log('Obj..............',Obj)
   this.setState({ open: true, uploadDocumentObj: Obj});
    Alert.closeAll();
  }

  handleAlertClick = (docId) => {
    this.props.deleteUploadedDocument(docId, this.state.userId,folderNames.SUB);
    Alert.closeAll();
  }
  handleDeleteClick = (docId) => {
    let warningMsg = 'Are you sure you want to delete this document?';
    alertConfirmation(warningMsg, {
      customFields: {
        displayComponent: true,
        handleButtonClick: () => this.handleAlertClick(docId),
        id: docId,
      },
    });
  }

  CheckDocument(e, index, data) {  
    let selectedDocumentIds = this.state.selectedDocumentIds;
  
    let isDocumentChecked = e.target.checked;
    if (isDocumentChecked) {    
      selectedDocumentIds.push(data.id);
    } else {    
      index = selectedDocumentIds.findIndex((value) => value === data.id);
      if (index >= 0) {
        selectedDocumentIds.splice(index, 1);
      }
    }
    this.setState({ selectedDocumentIds });
  }
  
  handleMoveDocumentClick = () => {
    this.setState({
      openBatchMoveModal : true
    })
  }

  ResetAllDocuments() { 
    if(this.state.clientDocs)
    {
      let clientDocs = this.state.clientDocs;  
      clientDocs.forEach((obj, Index) => {
        let documentIdCheck = `Documents[${Index}].Chk`;
        this.props.dispatch(change('DocumentSubFolderDetailsListingForm', documentIdCheck, false));
      });  
    }
    this.setState({ clientDocs:[], selectedDocumentIds : [] });
  }
  
  handleSelectAllClick= (e, isAllDocumentChecked) => {  
    let clientDocs = this.state.clientDocs;  
    let selectedDocumentIds = [];
    if(clientDocs && clientDocs.length > 0) {
      clientDocs.forEach((obj, Index) => {    
        let documentIdCheck = `Documents[${Index}].Chk`;
        if (obj && isAllDocumentChecked) {      
          selectedDocumentIds.push(obj.id);
          this.props.dispatch(change('DocumentSubFolderDetailsListingForm', documentIdCheck, true));
        } else {
          this.props.dispatch(change('DocumentSubFolderDetailsListingForm', documentIdCheck, false));
        }
      });
    }
    this.setState({  selectedDocumentIds });
  }

  handleAlertInactiveDocumentsClick = (event) => {
    this.props.BatchInactiveDocuments(this.state.selectedDocumentIds.toString(),folderNames.SUB);
    Alert.closeAll();
  }
  
  handleBatchInactiveDocuments = (event) => {
    Alert.warning('Are you sure you want to inactive selected documents?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertInactiveDocumentsClick,
        //id: obj.id,
      },
    });
  }
  
  handleAlertActiveDocumentsClick = (event) => {
    this.props.BatchActiveDocuments(this.state.selectedDocumentIds.toString(),folderNames.SUB);
    Alert.closeAll();
  }
  
  handleBatchActiveDocuments = (event) => {
    Alert.warning('Are you sure you want to active selected documents?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertActiveDocumentsClick,
        //id: obj.id,
      },
    });
  }
  
  
  handleAlertDeleteDocumentsClick = (event) => {
    this.props.BatchDeleteDocuments(this.state.selectedDocumentIds.toString(),folderNames.SUB);
    Alert.closeAll();
  }
  
  handleBatchDeleteDocuments = (event) => {
    Alert.warning('Are you sure you want to delete selected documents?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertDeleteDocumentsClick,
        //id: obj.id,
      },
    });
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadDataDetails();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadDataDetails();
    }
  }
  
  closeDialog = () => {     
    this.setState({ openBatchMoveModal: false,  selectedDocumentIds: [] });
  }


  onDateChange(input, value) {
    //input.onChange(value);
    input.onChange(moment(value).format());    
    if (this.state.userId) {
      this.setState({ [input.name]: value },()=>{          
        this.loadDataDetails();
      });
    }
  }

  handleReset() {
    // this.props.dispatch(change('DocumentSubFolderDetailsListingForm', 'startDate', null));
    // this.props.dispatch(change('DocumentSubFolderDetailsListingForm', 'endDate', null));
    this.props.dispatch(change('DocumentSubFolderDetailsListingForm', 'documentType', null));
    this.props.dispatch(change('DocumentSubFolderDetailsListingForm', 'ShowOnlyExpiredDocuments', false));
    this.props.dispatch(change('DocumentSubFolderDetailsListingForm', 'ShowOnlyInactiveDocuments', false));    
    this.setState({
        ShowOnlyExpiredDocuments: false,
        ShowOnlyInactiveDocuments: false,
        documentTypeId: 0,
        FromDate: new Date().setDate(new Date().getDate() - 1825),
        ToDate: new Date(),
      },()=>{this.loadDataDetails()});
  };

  handleAdvanceFilterCheck = (input, name) => {
    this.setState({ [name]: input.target.checked },
      () => {
        this.loadDataDetails();
      });
  }

  renderDownloadDocsDetails = () => {
    if ((this.state.clientDocs && this.state.clientDocs.length === 0) || (this.state.clientDocs.length === undefined)) {
      return (
        <div className="col-sm-12 mt20">
          <div className="familydl text-center no-record">
              No document found.
          </div>
        </div>
      );
    }
    let extension;
    if (this.state.clientDocs && this.state.clientDocs.length > 0) {
      // console.log('this.state.clientDocs-------', this.state.clientDocs);
      return this.state.clientDocs.map((obj, index) => {
        extension = obj.url.split('.').pop();
        let extensionArr = ['jpg', 'jpeg', 'png', 'txt', 'docx', 'doc', 'xlsx', 'pdf', 'pptx'];
        let fileExtensionCheck = extensionArr.find((o) => o === extension);
        if (fileExtensionCheck) {
          let imgUrl = '';
          if (fileExtensionCheck === 'jpg' || fileExtensionCheck === 'jpeg') {
            imgUrl = JPG;
          } else if (fileExtensionCheck === 'png') {
            imgUrl = PNG;
          } else if (fileExtensionCheck === 'txt') {
            imgUrl = TXT;
          } else if (fileExtensionCheck === 'pdf') {
            imgUrl = PDF;
          } else if (fileExtensionCheck === 'docx' || fileExtensionCheck === 'doc') {
            imgUrl = DOC;
          } else if (fileExtensionCheck === 'xlsx') {
            imgUrl = EXCEL;
          } else if (fileExtensionCheck === 'pptx') {
            imgUrl = PPT;
          } else {
            imgUrl = OTHER;
          }
          return (
            <div className="col-sm-6 history_card mt20" key={index}>
              <Card>
                <div className="cardchkbtn"> 
                  <Field
                    name={`Documents[${index}].Chk`}
                    component={renderCheckBox}
                    onChange={(e) => this.CheckDocument(e, index, obj)}
                    style={stylescss.checkbox}
                  />                  
                </div>
                <div className="clearfix"></div> 
                <div className="cardactbtn">
                
                  {this.props.deletePermission ?
                    <button onClick={(e) => this.handleEditClick(obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null}
                  {this.props.downloadPermission ?
                      <button onClick={(e) => this.handlePreviewClick(obj.id, obj.url)} type="button" title="Preview" className="tbactionbtn bluefont"><i className="fa fa-eye" aria-hidden="true"></i></button>
                      : null}
                  {this.props.downloadPermission ?
                    <button onClick={(e) => this.handleDownloadClick(obj.id, obj.url)} type="button" title="Download" className="tbactionbtn bluefont"><i className="fa fa-download" aria-hidden="true"></i></button>
                    : null}
                  {this.props.deletePermission ?
                    <button onClick={(e) => this.handleDeleteClick(obj.id)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                    : null}
                  <div className="filetype">
                    <img src={imgUrl} alt="text" title={obj.url} />
                  </div>
                </div>
                <div className="carditems">
                  <ul>
                    <li>Document Title: <span>{obj.documentTitle}</span></li>
                    <li>Document Type: <span>{obj.documentTypeName}</span></li>
                    <li>Uploaded Date: <span>{showFormatedDate(obj.createdDate || new Date())}</span></li>
                    {!obj.expiration ? <li>Expiration Date: <span>No Expiration</span> </li> : <li>Expiration Date: <span>{moment(obj.expiration).format('MM/DD/YYYY')}</span></li>}
                    <li>Active Document: <span className={obj.isActive === true ? 'greenfont' : 'redfont'}>{obj.isActive ? 'Yes' : 'No'}</span></li>
                  </ul>
                </div>
              </Card>
            </div>
          );
        }
      });
    }
  }

  renderDocumentListingPanel() {
    return (
      <div>
         <h2 className="page_title">Manage Folders {' > '} {this.state.masterFolderName} {' > '} {this.state.subFolderName}</h2>
          <div className="clearfix"></div>
          <div>              
              <div className="row">             
              
                {/* <div className="col-sm-4 mt-30">
                  <Field
                    name="clients"
                    label="client"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.clientsList}
                    component={renderAutoCompleteSingleSelect}/>
                </div> */}
                 
                <div className="col-sm-4">
                  {/* <Field
                    name="startDate"
                    placeholder="From Date"
                    onDateChange={this.onDateChange}
                    selected={this.props.selectorStartDate}
                    component={renderDateField}/> */}
                    <Field name="FromDate"
                            placeholder="From Date"
                            locale="en-US"
                            selected={this.state.FromDate}
                            onDateChange={this.onDateChange}
                            openToYearSelection = {true}
                            component={renderDateField} />
                </div>
                <div className="col-sm-4">
                  {/* <Field
                    name="endDate"
                    placeholder="To Date"
                    onDateChange={this.onDateChange}
                    selected={this.props.selectorEndDate}
                    component={renderDateField}/> */}
                    <Field name="ToDate"
                            placeholder="To Date"
                            locale="en-US"
                            selected={this.state.ToDate}
                            onDateChange={this.onDateChange}
                            openToYearSelection = {true}
                            component={renderDateField} />
                </div>   
                <div className="col-sm-4 mt-30">
                  <Field
                      name="documentType"
                      label="Document Type"
                      component={renderAutoCompleteSingleSelect}
                      options={this.state.documentTypes}
                      handleNewRequest={this.handleNewRequest}
                    />
                </div>               
              </div>
              <div className="row">
                <div className="col-sm-4">
                    <Field
                      name="patientDocs"
                      floatingLabelText="Search"
                      maxLength='25'
                      onChange={this.handleSearchChange}
                      component={renderTextField}
                    />
                </div>
                <div className="col-sm-3 mt-30">
                    <Field
                        name="ShowOnlyExpiredDocuments"
                        label="Show expired documents only"
                        component={renderCheckBox}
                        onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowOnlyExpiredDocuments')}
                      />
                </div>      
                <div className="col-sm-3 mt-30">
                    <Field
                        name="ShowOnlyInactiveDocuments"
                        label="Show inactive documents only"
                        component={renderCheckBox}
                        onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowOnlyInactiveDocuments')}
                      />
                </div>                        
                <div className="reset-btn col-sm-2 mt-30 btn_rt">
                  <CommonButton className="grey_btn" onTouchTap={this.handleReset} label = 'Reset' />
                </div>                  
            </div>
          </div>
          {this.props.uploadPermission ?
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 reset-btn claims_btn">                  
                    <RaisedButton label="Back" primary={true} onTouchTap={() => this.props.onBackClick()} />
                    <CommonButton className="ml_15 mt-20" label="Upload Document" primary={true} onTouchTap={this.uploadDocumenthandler} />                    
                    <RaisedButton className={"grey_btn ml_15"}  onTouchTap={(e) => this.handleSelectAllClick(e, (this.state.selectedDocumentIds.length > 0  ? false : true))} >{this.state.selectedDocumentIds.length > 0 ? "Deselect All" : "Select All"}</RaisedButton>
                    <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleMoveDocumentClick(e)} >Bulk Move Documents</RaisedButton>
                    <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}  disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchInactiveDocuments(e)} >Bulk Inactive Documents</RaisedButton>
                    <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}  disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchActiveDocuments(e)} >Bulk Active Documents</RaisedButton>
                    <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}  disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchDeleteDocuments(e)} >Bulk Delete Documents</RaisedButton>
              </div>
            </div>
          : null}
        <div className="row">      
          {!this.state.userId ?
            (<div className="col-sm-12 mt20">
              <div className="familydl text-center no-record">
                    No client selected.
              </div>
            </div>)
            : this.renderDownloadDocsDetails()}

           {
            this.state.openBatchMoveModal === true && <MoveBatchDocumentsIntoFolderModal
            folderType="SUB FOLDER"
            selectedDocumentIds={this.state.selectedDocumentIds}
            userDocumentMasterFolders={this.state.userDocumentMasterFolders.filter((obj) => obj.userId === this.state.userId && obj.userTypeName === 'PATIENT')}
            userDocumentSubFolders={this.state.userDocumentSubFolders.filter((obj) => obj.userId === this.state.userId)}
            closeDialog={this.closeDialog}
            />
          }
        </div>
      </div>
    );
  }



  render() {
    return (
      <div className="col-sm-12">
        {this.state.open ? <UploadDocumentModal folderName={folderNames.SUB} uploadDocumentObj={this.state.uploadDocumentObj} UserID={this.state.userId} closeDialog={this.handleCloseHandler} documentTypes={this.state.documentTypes}  userDocumentMasterFolders={this.state.userDocumentMasterFolders.filter((obj) => obj.userId === this.state.userId  && obj.userTypeName === 'PATIENT')} userDocumentSubFolders={this.state.userDocumentSubFolders.filter((obj) => obj.userId === this.state.userId)} ShowOnlyInactiveDocuments={this.state.ShowOnlyInactiveDocuments} ShowOnlyExpiredDocuments={this.state.ShowOnlyExpiredDocuments} /> : ''}       
          {/* <div className="col-sm-12"> */}
            {/* <h2 className="page_title">Document Upload</h2>
            <div className="clearfix"></div> */}
            {/* <div className="readmin-panel">
              <div className="panel-body"> */}
                {this.renderDocumentListingPanel()}
              {/* </div>
            </div> */}
          {/* </div> */}
      </div>
    );
  }
}

DocumentSubFolderDetails = reduxForm({
  form: 'DocumentSubFolderDetailsListingForm',
})(DocumentSubFolderDetails);

const selector = formValueSelector('DocumentSubFolderDetailsListingForm');

function mapStateToProps(state, ownProps) {
  // debugger;
  // Start For Role Permission
  let userActionPermission = [];//,
    // selectorStartDate = selector(state, 'startDate'),
    // selectorEndDate = selector(state, 'endDate');
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'CLIENT_DOCUMENT_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let uploadPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_DOCUMENT_LIST_UPLOAD')[0].permission : false;
  let downloadPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_DOCUMENT_LIST_DOWNLOAD')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_DOCUMENT_LIST_DELETE')[0].permission : false;

  // End For Role Permission

  // let clientsByLocation = [];
  // if (state.user.clientsAndPatientsByLocation && state.user.clientsAndPatientsByLocation.data) {
  //   clientsByLocation = state.user.clientsAndPatientsByLocation.data.client || [];
  // }

  //console.log('state.patient.patientDocumentDownload123.............',state.patient.patientDocumentDownload, state.patient.saved_MoveBatchDocumentsIntoFolder)

  return {
    currentLocationId: state.login.currentLocationId,
    //clientsList: clientsByLocation,
    loading: state.patient.loading,
    masterData: state.user.master_data,
    clientDocs: state.patient.patientDocumentDownload,
    delete_Uploaded_Document: state.patient.delete_Uploaded_Document,
    uploadPermission: uploadPermission,
    downloadPermission: downloadPermission,
    deletePermission: deletePermission,
    userInfo: state.user.userInfo, // client user ID for documents
    // selectorStartDate,
    // selectorEndDate,  
    saved_MoveBatchDocumentsIntoFolder: state.patient.saved_MoveBatchDocumentsIntoFolder,
    inactivated_MoveBatchDocuments: state.patient.inactivated_MoveBatchDocuments,    
    deleted_MoveBatchDocuments: state.patient.deleted_MoveBatchDocuments,    
  };
}


export default connect(mapStateToProps, { getMasterData, documentUploadDownload, uploadedDocumentDownload, deleteUploadedDocument, PreviewDownloadedDocument, BatchInactiveDocuments, BatchActiveDocuments, BatchDeleteDocuments })(DocumentSubFolderDetails);



// WEBPACK FOOTER //
// ./src/modules/patients/components/uploadDocuments/DocumentSubFolderDetails.js